angular.module('pitch.search')
.controller('PitchSearchFormCtrl', function ($scope, $controller, SearchConfig) {
    'use strict';

    angular.extend(this, $controller('SearchFormCtrl', {
        $scope: $scope
    }));

    if (!SearchConfig.isset('fields')) {
        SearchConfig.toggle('fields', 'name', true);
        SearchConfig.toggle('fields', 'artistName', true);
        SearchConfig.toggle('fields', 'writerName', true);
        SearchConfig.toggle('fields', 'productTitle', true);
        SearchConfig.toggle('fields', 'keywordName', true);
        SearchConfig.toggle('fields', 'labelName', true);
    }
});



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/controllers/PitchSearchFormCtrl.js